import { useUserTimeZone } from '../useUser/useUserTimeZone'
import { useList, type UseListProps } from '../useList'
import type { SetOptional } from 'type-fest'
import { notifcationQuery } from './graphql'
import { StorageType } from '../useListAction/types'

export const useNotificationList = ({
  listActionOptions = {},
  query,
  ...props
}: SetOptional<UseListProps, 'query'>) => {
  const timeZone = useUserTimeZone()

  query = query ?? notifcationQuery.allConfig.query

  const finalDefaultListActions = {
    limit: 100,
    ...listActionOptions,
    storageType: listActionOptions.storageKey ? StorageType.localStorage : StorageType.none,
    timeZone,
  }

  return useList({
    query,
    ...props,
    sort: { createdAt: -1 },
    listActionOptions: finalDefaultListActions,
  })
}
